import { FC } from 'react'

type Props = {
  authorTitle?: string | null
}

const ContentBlockAuthorTitle: FC<Props> = ({ authorTitle }) => (
  <>
    {authorTitle && (
      <div>
        <p className="mb-4 font-bold text-grey-90 text-16">Автор</p>
        <div className="line-clamp-2 whitespace-pre-line font-pro text-16">
          {authorTitle}
        </div>
      </div>
    )}
  </>
)

export { ContentBlockAuthorTitle }
